import { useStore } from 'vuex'

export function useAlert () {
  const store = useStore()

  function closeAlert () {
    store.commit('setShowAlert', false)
  }

  function alertFailed ({ message = 'Terjadi Kesalahan' }) {
    store.commit('setAlertType', 'failed')
    store.commit('setAlertMessage', message)
    store.commit('setShowAlert', true)
  }

  function alertConfirmation ({ message = 'Apakah anda yakin ingin melanjutkan ?', callback }) {
    store.commit('setAlertType', 'confirmation')
    store.commit('setAlertMessage', message)
    store.commit('setAlertCallback', callback)
    store.commit('setShowAlert', true)
  }

  function alertNormal ({ message = 'Berhasil' }) {
    store.commit('setAlertType', 'normal')
    store.commit('setAlertMessage', message)
    store.commit('setShowAlert', true)
  }
  function alertNormalWithCallback ({ message = 'Berhasil', callback }) {
    store.commit('setAlertType', 'normalCallback')
    store.commit('setAlertMessage', message)
    store.commit('setAlertCallback', callback)
    store.commit('setShowAlert', true)
  }

  return {
    closeAlert,
    alertFailed,
    alertConfirmation,
    alertNormal,
    alertNormalWithCallback
  }
}
